import { render, staticRenderFns } from "./DefaultChannels.html?vue&type=template&id=ac479f54&scoped=true&"
import script from "./DefaultChannels.js?vue&type=script&lang=js&"
export * from "./DefaultChannels.js?vue&type=script&lang=js&"
import style0 from "./DefaultChannels.scss?vue&type=style&index=0&id=ac479f54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac479f54",
  null
  
)

export default component.exports